import React from 'react';
import { ArrowUpRight, Menu, Share2, Grid, Star } from 'lucide-react';
import './index.css';

const Apple = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  return (
    <div className="min-vh-100 text-white" >
      {/* Navigation */}
      <nav className="navbar navbar-dark bg-opacity-90 px-3">
        <div className="d-flex align-items-center gap-2">
          <Share2 className="h-6 w-6" />
          <span className="fs-4 fw-semibold">DeFiChain</span>
        </div>
        <button 
          className="btn btn-purple px-4"
          onClick={handleOpen}
        >
          Connect Wallet
        </button>
      </nav>

      {/* Hero Section */}
      <main className="container py-5">
        <div className="col-12 col-lg-8">
          <h1 className="display-4 fw-bold mb-4">
            A Growing Protocol Ecosystem
          </h1>
          <p className="fs-4 text-light-emphasis mb-4">
            We build a suite of tools for the world of decentralized finance. 
            A suite of tools designed to help you manage any operation with crypto tokens 
            and launchpads in a fast and simple way, with no prior code knowledge 
            required and 100% decentralized!
          </p>
        </div>

        {/* Protocol Section */}
        <div className="mt-5">
          <h2 className="display-5 fw-bold mb-2">
            Cross-Chain
          </h2>
          <h3 className="display-5 fw-bold mb-4">
            Router Protocol
          </h3>
          <p className="fs-4 text-light-emphasis mb-4">
            The Ultimate Router for Web3.0
          </p>
          
          <div className="d-flex gap-3 mb-5">
            <button  onClick={handleOpen} className="btn btn-purple px-4 py-2">Explorer</button>
            <button  onClick={handleOpen} className="btn btn-success px-4 py-2">Enter App</button>
          </div>
        </div>

        {/* Categories Section */}
        <div className="mt-5">
          <h3 className="fs-2 mb-3">Please select Issue Category</h3>
          <p className="text-purple mb-4">Which of this is related to your issue?</p>

          <div  onClick={handleOpen} className="card bg-dark-subtle border-secondary mb-3 cursor-pointer">
            <div className="card-body p-4">
              <div className="d-flex align-items-center gap-3">
                <Grid className="h-8 w-8" />
                <div>
                  <h4 className="fs-4 fw-semibold mb-1">Swap/Exchange</h4>
                  <p className="text-primary mb-0">Click here for any issues with swapping/exchange of coins</p>
                </div>
              </div>
            </div>
          </div>

          <div  onClick={handleOpen} className="card bg-dark-subtle border-secondary cursor-pointer">
            <div className="card-body p-4">
              <div className="d-flex align-items-center gap-3">
                <Star className="h-8 w-8" />
                <div>
                  <h4 className="fs-4 fw-semibold mb-1">Token Allocation</h4>
                  <p className="text-primary mb-0">Click here for Token Allocation</p>
                </div>
              </div>
            </div>
          </div>

          <div  onClick={handleOpen} className="card bg-dark-subtle border-secondary mb-3 cursor-pointer">
            <div className="card-body p-4">
              <div className="d-flex align-items-center gap-3">
                <Grid className="h-8 w-8" />
                <div>
                  <h4 className="fs-4 fw-semibold mb-1">Connect to DApp</h4>
                  <p className="text-primary mb-0">Click here to connect decentralised web applications to mobile wallets or enable 
                    DApp on mobile wallets/extension
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div  onClick={handleOpen} className="card bg-dark-subtle border-secondary mb-3 cursor-pointer">
            <div className="card-body p-4">
              <div className="d-flex align-items-center gap-3">
                <Grid className="h-8 w-8" />
                <div>
                  <h4 className="fs-4 fw-semibold mb-1">Login issues</h4>
                  <p className="text-primary mb-0">Click here for any issues logging into your wallet</p>
                </div>
              </div>
            </div>
          </div>

          <div  onClick={handleOpen} className="card bg-dark-subtle border-secondary mb-3 cursor-pointer">
            <div className="card-body p-4">
              <div className="d-flex align-items-center gap-3">
                <Grid className="h-8 w-8" />
                <div>
                  <h4 className="fs-4 fw-semibold mb-1">Network Activation</h4>
                  <p className="text-primary mb-0">Click here to activate our multichain Network.</p>
                </div>
              </div>
            </div>
          </div>

          <div  onClick={handleOpen} className="card bg-dark-subtle border-secondary mb-3 cursor-pointer">
            <div className="card-body p-4">
              <div className="d-flex align-items-center gap-3">
                <Grid className="h-8 w-8" />
                <div>
                  <h4 className="fs-4 fw-semibold mb-1">Exhorbitant Gas fees</h4>
                  <p className="text-primary mb-0">Click here to Rectify</p>
                </div>
              </div>
            </div>
          </div>

          <div  onClick={handleOpen} className="card bg-dark-subtle border-secondary mb-3 cursor-pointer">
            <div className="card-body p-4">
              <div className="d-flex align-items-center gap-3">
                <Grid className="h-8 w-8" />
                <div>
                  <h4 className="fs-4 fw-semibold mb-1">Transaction Error</h4>
                  <p className="text-primary mb-0">Do you have any issues with transactions? Click here to rectify</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </main>

      {/* Modal */}
      {isOpen && (
        <>
          {/* Overlay */}
          <div 
            className="fixed-top vw-100 vh-100"
            style={{
              backgroundColor: 'rgba(0, 0, 0, 0.75)',
              zIndex: 1050,
            }}
            onClick={handleOverlayClick}
          />
          
          {/* Modal */}
          <div 
            className="modal d-block" 
            tabIndex="-1"
            style={{ zIndex: 1051 }}
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content bg-dark text-white">
                <div className="modal-body text-center p-4">
                  <h3 className="fw-semibold mb-3">Connection Blocked</h3>
                  <p className="text-secondary mb-4">Please connect manually</p>
                  <a 
                    href="/#/connect" 
                    className="text-decoration-none"
                  >
                    <button className="btn btn-primary w-full px-4">
                      OK
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Apple;